/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_Recording_ShortInputs */

const en_us2_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording`)
};

const pt_br2_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravando`)
};

const es_419_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grabando`)
};

const pt_pt2_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gravar`)
};

const fr_fr2_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement`)
};

const de_de2_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme`)
};

const it_it2_coach_mic_recording_short = /** @type {(inputs: Coach_Mic_Recording_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione`)
};

/**
* | output |
* | --- |
* | "Recording" |
*
* @param {Coach_Mic_Recording_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_recording_short = /** @type {((inputs?: Coach_Mic_Recording_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_Recording_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_recording_short(inputs)
	if (locale === "es-419") return es_419_coach_mic_recording_short(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_recording_short(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_recording_short(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_recording_short(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_recording_short(inputs)
	return en_us2_coach_mic_recording_short(inputs)
});
export { coach_mic_recording_short as "coach-mic.recording_short" }